import { DEPTWITHUSERANDCOLLABORATORS, GETDEPARTMENT, GETDEPARTMENTDETAIL, RESET_REDUX_STATE } from "../constants";

const initState = {
  departmentList: [],
  departmentDetail: {},
  deptWithUserAndCollaborators: {}
};

const department = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GETDEPARTMENT: {
      return {
        ...state,
        departmentList: payload,
      };
    }
    case GETDEPARTMENTDETAIL: {
      return {
        ...state,
        departmentDetail: payload,
      };
    }

    case DEPTWITHUSERANDCOLLABORATORS: {
      return {
        ...state,
        deptWithUserAndCollaborators: payload,
      };
    }
    case RESET_REDUX_STATE: {
      return initState
    }
    default:
      return state;
  }
};

export default department;
